'use strict';
var m;

angular.module('harriApp')
    .controller('MemberProfilesController', ['$location', '$scope', '$state', 'hUser', 'sharedData', 'searchBackend', '$timeout', '$rootScope', '$modal', 'appLayoutViewService', function ($location, $scope, $state, hUser, sharedData, searchBackend, $timeout, $rootScope, $modal, appLayoutViewService) {
    $scope.profile_media = window.profile_media;
    $scope.user = hUser.data.user;
    $scope.isPrivacyShield = hUser.isPrivacyShieldOn();
        hUser.isFromUK().then(function(isFromUk){
            $scope.isFromUK = isFromUk;
        });

    $scope.state = $state.current;
    $scope.peopleCount = 0;


    $scope.init = function( ){
        $scope.isEmployer = hUser.isEmployer();
        if (window.brandName) {
            $scope.brandName = window.brandName;
        }

        appLayoutViewService.updateBrandTheme()
            .finally(function () {
                $scope.$evalAsync();
            });

    }


      $scope.onSearchOpen = function (isShown) {
          $scope.searchOpen = isShown;
          $scope.$evalAsync();
      };

      $scope.isSideBarExpanded = function () {
          return appLayoutViewService.isSideBarExpanded();
      };

      $scope.getToggleSource = function () {
          return appLayoutViewService.getToggleSource();
      };

    $scope.init();
}])
.factory('sharedData', [function () {

    var data = {
        'user_id' : null,
        'job_id' : null,
        'list_of_jobs' : null,
    }

    return data;
}])
